// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import { Flex, Stack } from '@mantine/core';

import {
  type DetailSectionProps,
  DetailSection,
  DetailSectionTitle,
} from 'components/Mantine/DetailPage/DetailSection';

type Props = DetailSectionProps & {
  /** @defaultValue true */
  enableDetailSection?: boolean;
  /** Props applied to the {@link Stack} when `enableDetailSection` is `false` */
  stackProps?: Stack.Props;
};

/** Used to render either a standard {@link DetailSection} or just a Stack with a title */
export const OptionalDetailSection = ({
  title,
  tooltip,
  rightSection,
  enableDetailSection = true,
  stackProps,
  large,
  children,
  ...props
}: Props) =>
  enableDetailSection ? (
    <DetailSection title={title} rightSection={rightSection} large={large} {...props}>
      {children}
    </DetailSection>
  ) : (
    <Stack {...stackProps}>
      <Flex justify="space-between" align="center">
        <DetailSectionTitle title={title} tooltip={tooltip} large={large} />
        <Flex align="center" gap="sm">
          {rightSection}
        </Flex>
      </Flex>
      {children}
    </Stack>
  );
